import Vue from 'vue';
import MPrompt from './MPrompt';


const createPrompt = function ({headerText, bodyText, cancelText, okText, sizeModal}, okButtonType) {
    let vueComponent = null;
    return new Promise((resolve, reject) => {
        vueComponent = new Vue({
            render (h) {
                return h(MPrompt, {
                    props: {
                        headerText, bodyText, cancelText, okText, okButtonType, sizeModal
                    },
                    on: {
                        ok () {
                            resolve();
                        },
                        cancel () {
                            reject(new Error('CANCEL_CLICKED'));
                        }
                    }
                });
            }
        });
        vueComponent.$mount();
        document.body.append(vueComponent.$el);
    }).finally(async () => {
        const prompt = vueComponent.$children[0];
        await prompt.removePrompt();
        vueComponent.$el.remove();
        vueComponent.$destroy();
    });
};

const showRegular = (params) => createPrompt(params, 'regular');


const showDanger = (params) => createPrompt(params, 'critical');

export default {
    show: showRegular,
    danger: showDanger
};
